import { c as _c } from "react/compiler-runtime";
import { parseGid } from "@shopify/hydrogen-react/analytics-utils";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import Script from "next/script";
import type { ImageObject as ImageObjectSchema, ProductGroup as ProductGroupSchema, WithContext } from "schema-dts";
// import { transformShopifyImageToNextImage } from '@repo/shopify'
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { Image_Fragment, MediaImage_Fragment, MediaConnectionMasked_Fragment, ProductOption_Fragment } from "#/graphql/shopify-storefront/fragments";
import { LinkedData_Localization_Fragment, LinkedData_Product_Fragment, LinkedData_ProductVariant_Fragment, LinkedData_Shop_Fragment, LinkedData_ProductVariantsConnectionMasked_Fragment } from "#/components/linked-data/graphql";
import { transformShopifyImageToImageObjectSchema } from "../../utilities/linked-data";
import { transformShopifyProductToAggregateOfferSchema, transformShopifyOfferToOfferSchema, transformShopifyProductVariantMaskedToSizeSpecificationSchema } from "../../utilities/linked-data";
export function LinkedDataProductGroup(t0) {
  const $ = _c(18);
  const {
    id,
    localizationMasked,
    productMasked,
    shopMasked
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== id || $[1] !== localizationMasked || $[2] !== productMasked || $[3] !== shopMasked) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const shop = readFragmentShopifyStorefront(LinkedData_Shop_Fragment, shopMasked);
      const logoImage = readFragmentShopifyStorefront(Image_Fragment, shop.brand?.logo?.image);
      const logo = {
        "@context": "https://schema.org",
        "@type": "ImageObject",
        about: shop.name,
        description: shop.brand?.logo?.alt ?? shop.brand?.logo?.alt ?? shop.name,
        height: logoImage?.height?.toString(),
        representativeOfPage: false,
        width: logoImage?.width?.toString(),
        url: logoImage?.url
      } satisfies WithContext<ImageObjectSchema>;
      const product = readFragmentShopifyStorefront(LinkedData_Product_Fragment, productMasked);
      if (!product) {
        t6 = null;
        break bb0;
      }
      const {
        mediaConnectionMasked,
        optionsMasked,
        variantsConnectionMasked
      } = product;
      const media = readFragmentShopifyStorefront(MediaConnectionMasked_Fragment, mediaConnectionMasked);
      const imagesMasked = media.edges.map(_temp).filter(_temp2).map(_temp3).filter(_temp4).map(_temp5).filter(Boolean);
      const options = optionsMasked.map(_temp6);
      const variantsMasked = readFragmentShopifyStorefront(LinkedData_ProductVariantsConnectionMasked_Fragment, variantsConnectionMasked).edges.map(_temp7).filter(Boolean);
      const jsonLd = {
        "@context": "https://schema.org",
        "@type": "ProductGroup",
        brand: product.vendor,
        description: product.description,
        hasVariant: variantsMasked.map(variantMasked_0 => {
          const variant = readFragmentShopifyStorefront(LinkedData_ProductVariant_Fragment, variantMasked_0);
          return {
            "@type": "Product",
            brand: product.vendor,
            ...(variant.barcode && {
              gtin: variant.barcode
            }),
            color: variant.selectedOptions.find(_temp8)?.value,
            description: product.description,
            identifier: variant.id,
            ...(variant.image && {
              image: transformShopifyImageToImageObjectSchema({
                about: variant.title,
                imageMasked: variant.image
              })
            }),
            name: variant.title ?? variant.title,
            offers: transformShopifyOfferToOfferSchema({
              localizationMasked,
              productMasked,
              shopMasked,
              variantMasked: variantMasked_0
            }),
            productID: variant.id,
            size: transformShopifyProductVariantMaskedToSizeSpecificationSchema({
              variantMasked: variantMasked_0
            }),
            url: `/products/${product.handle}?${variant.selectedOptions.map(_temp9).join("&")}`,
            ...(variant.weight && {
              weight: {
                "@type": "QuantitativeValue",
                unitCode: "KGM",
                value: variant.weight
              }
            })
          };
        }),
        identifier: product.id,
        image: [...imagesMasked.map(imageMasked_0 => transformShopifyImageToImageObjectSchema({
          about: product.title,
          imageMasked: imageMasked_0
        })), logo],
        keywords: product.tags,
        mainEntityOfPage: `/products/${product.handle}`,
        name: product.title,
        offers: transformShopifyProductToAggregateOfferSchema({
          localizationMasked,
          productMasked,
          shopMasked
        }),
        productGroupID: product.id,
        url: `/products/${product.handle}`,
        ...(options && {
          variesBy: options?.map(_temp10)
        })
      };
      T0 = Script;
      t1 = id ?? `LinkedDataProductGroup-${parseGid(product.id).id}`;
      t2 = id ?? `LinkedDataProductGroup-${parseGid(product.id).id}`;
      t3 = "lazyOnload";
      t4 = "application/ld+json";
      t5 = JSON.stringify(jsonLd);
    }
    $[0] = id;
    $[1] = localizationMasked;
    $[2] = productMasked;
    $[3] = shopMasked;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t7 = <T0 id={t1} key={t2} strategy={t3} type={t4}>{t5}</T0>;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp10(option) {
  return option.name;
}
function _temp9(selectedOption_0) {
  return `${selectedOption_0.name.toLowerCase()}=${selectedOption_0.value.toLowerCase()}`;
}
function _temp8(selectedOption) {
  return selectedOption.name === "Color";
}
function _temp7(t0) {
  const {
    node: variantMasked
  } = t0;
  return variantMasked;
}
function _temp6(optionMasked) {
  return readFragmentShopifyStorefront(ProductOption_Fragment, optionMasked);
}
function _temp5(t0) {
  const {
    imageMasked
  } = t0;
  return imageMasked;
}
function _temp4(medium_0) {
  return medium_0.__typename === "MediaImage";
}
function _temp3(mediumMasked_0) {
  return readFragmentShopifyStorefront(MediaImage_Fragment, mediumMasked_0);
}
function _temp2(medium) {
  return medium.__typename === "MediaImage";
}
function _temp(t0) {
  const {
    node: mediumMasked
  } = t0;
  return mediumMasked;
}